module.exports = __webpack_public_path__ + "static/media/0009.d31d24fb.jpg";